import React, { Fragment, useCallback, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import Modal from 'react-modal';
import { translate } from '../../Services/translation';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel as Lightbox } from 'react-responsive-carousel';
import { useSelector, useDispatch } from 'react-redux';
import { show, setCurrentIndex } from '../../Actions/LightboxImages.action';
import useSmoothHorizontalScroll from 'use-smooth-horizontal-scroll';

const customStyles = {
    content: {
        background: 'none',
        padding: 0,
        border: 'none',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        zIndex: 2003,
    },
};
const LightboxSettings = {
    showStatus: false,
    showIndicators: false,
    useKeyboardArrows: true,
    autoPlay: false,
    autoFocus: true,
};


const VideoSlide = ({ url, isSelected, className }) => (
    <ReactPlayer controls={true} width="100%" height="100%" url={url} playing={false} />
);

const renderThumbnails = (children) => {
    const images = children.map((item, index) => {

        if (!item || !item.props || !item.props.children) {
            return undefined;
        }

        // find img to get source
        const imageElement = item.props.children;
        //const imageElement = item.props.children.find(
        //    (ele) => ele.type === 'img'
        //);


        if (!imageElement || !imageElement.props || !imageElement.props.src) {
            return undefined;
        }
        //const { html, type, src, videoSrc, title } = image;
        return (
            <div
                key={index}
                style={{
                    backgroundImage: 'url(' + imageElement.props.src + ')',
                }}
                className={`thumbnail__image ${imageElement.props.className}`}
            />
        );
    });

    return images;
};

const LightboxImages = (props) => {
    const dispatch = useDispatch();
    const flags = props.flags;
    const { visible, index } = useSelector((state) => state.lightboxImages);
    const onClose = useCallback(() => dispatch(show(false)), [dispatch]);
    const onClickThumbnail = (index, type) => {
        dispatch(show(true));
        dispatch(setCurrentIndex(index));
    };
    const { scrollContainerRef, handleScroll, scrollBy, scrollTo, isAtStart, isAtEnd } = useSmoothHorizontalScroll();
    const [lastScrollTop, setLastScrollTop] = useState(-1);

    useEffect(() => {
        if (!visible && lastScrollTop > -1) {
            setTimeout(() => {
                window.scrollTo({
                    top: lastScrollTop,
                });
            }, 10);
        }
    }, [visible]);

    return !props.images || props.images.length < 1 ? (
        <Fragment />
    ) : (
        <Fragment>
            <div className="row product-images">
                <div className="small-12 columns">
                    <figure className="product-detail__image-container">
                        {flags &&
                                <div className="product-item__flag-wrapper">
                                {flags?.map((flag, index) => (
                                    <span key={`flag-wrap-${index}`} className="product-item__flag">{flag}</span>
                                ))}
                            </div>
                        }
                        <a
                            data-src={props.images[0].src}
                            href="#"
                            itemProp="url"
                            onClick={(e) => {
                                e.preventDefault();
                                setLastScrollTop(window.scrollY);
                                onClickThumbnail(0);
                            }}
                            tilte={props.images[0].title}
                            className="product-image"
                            rel="nofollow"
                            dangerouslySetInnerHTML={{
                                __html: props.images[0].html,
                            }}
                        ></a>
                    </figure>
                </div>
                {props.images?.length > 1 &&
                    <div className={`small-12 columns product-detail__thumbnail-wrapper`}>
                        {!(isAtStart && isAtEnd) &&
                            <button className="product-detail__thumbnail-container-scroll--left" onClick={() => scrollTo(-100)} disabled={isAtStart}>
                                {'<'}
                            </button>
                        }
                        <div className={`row ${isAtStart && !isAtEnd ? '' : 'align-center'} product-detail__thumbnail-container ${!(isAtStart && isAtEnd) ? 'scroll--active' : ''}`} ref={scrollContainerRef} onScroll={handleScroll} style={{ overflowX: "scroll" }}>
                            {props.images.map(
                                (image, index) => {
                                    if (index > 0) {
                                        const { html, type, src, videoSrc, title } = image;
                                        return (
                                            <div
                                                className="product-detail__image-container columns product-detail__thumb-container"
                                                key={index}
                                            >
                                                <a
                                                    data-src={src}
                                                    data-video-src={videoSrc}
                                                    href="#"
                                                    itemProp="url"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        onClickThumbnail(index, type);
                                                    }}
                                                    className={`${type === 'video' ? 'video' : ''} product-image`}
                                                    rel="nofollow"
                                                    title={title}
                                                    dangerouslySetInnerHTML={{
                                                        __html: html,
                                                    }}
                                                ></a>
                                            </div>
                                        );
                                    }
                                }
                            )}
                        </div>
                        {!(isAtStart && isAtEnd) &&
                            <button className="product-detail__thumbnail-container-scroll--right" onClick={() => scrollTo(100)} disabled={isAtEnd}>
                                {'>'}
                            </button>
                        }
                    </div>
                }
            </div>
            <Modal
                ariaHideApp={false}
                preventScroll={true}
                isOpen={visible}
                onRequestClose={onClose}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
            >
                <button
                    onClick={onClose}
                    className="light-box__close-btn"
                >
                    <span>{translate('common.close')}</span>

                </button>
                <Lightbox
                    {...LightboxSettings}
                    selectedItem={index}
                    className="light-box"
                    renderThumbs={renderThumbnails}
                >
                    {props.images.map((value, index) => {
                        const { html, type, src, videoSrc, title } = value;
                        return (
                            <div
                                key={`figure${index}`}
                                className="light-box__container"
                            >
                                {type === 'video' ? (<VideoSlide src={src} url={videoSrc} isSelected={true} className="light-box__video" />) : (<img alt={title} src={src} className="light-box__image" />)}

                            </div>
                        );
                    })}
                </Lightbox>
            </Modal>
        </Fragment>
    );
};

export default LightboxImages;
